import React from "react";
import { ArrowRight } from "lucide-react";

const HERO_IMG = "/hero/ashley-race.jpg";

const goTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate overflow-hidden min-h-[100svh] flex items-end pb-16 lg:pb-24 pt-28"
    >
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_IMG}
          alt="Ashley Kempson racing at sunrise"
          className="h-full w-full object-cover object-[70%_0%]"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />
        <div className="absolute inset-0 diagonal-stripes opacity-50" />
      </div>

      {/* Outline marquee */}
      <div className="absolute top-24 left-0 right-0 overflow-hidden pointer-events-none">
        <div className="marquee-track animate-marquee-slow whitespace-nowrap">
          {Array.from({ length: 6 }).map((_, i) => (
            <span
              key={i}
              className="font-display outline-text text-[14vw] leading-none px-8"
            >
              PRECISION RUNNING — TRAIN WITH INTENT —
            </span>
          ))}
        </div>
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="max-w-5xl">
          <div className="flex items-center gap-3 mb-6 animate-rise">
            <span className="h-px w-10 bg-brand-red" />
            <span className="label-eyebrow text-white/80">Online Run Coaching</span>
          </div>
          <h1
            data-testid="hero-headline"
            className="font-display uppercase text-white text-[16vw] sm:text-[12vw] lg:text-[9vw] leading-[0.85] tracking-tighter animate-rise"
            style={{ animationDelay: "0.05s" }}
          >
            Train with <span className="text-brand-red">precision.</span><br />
            Race with <span className="italic font-sans font-light tracking-tight">conviction.</span>
          </h1>
          <p
            className="mt-8 max-w-2xl text-white/70 text-lg lg:text-xl leading-relaxed animate-rise"
            style={{ animationDelay: "0.15s" }}
          >
            Personalised programs for runners chasing their first 5K to their fastest
            half-marathon. Built by Ashley Kempson — coached, adjusted, and progressed every week.
          </p>

          <div
            className="mt-10 flex flex-wrap items-center gap-4 animate-rise"
            style={{ animationDelay: "0.25s" }}
          >
            <button
              onClick={() => goTo("contact")}
              data-testid="hero-cta-primary"
              className="btn-primary"
            >
              Start your plan <ArrowRight size={16} />
            </button>
            <button
              onClick={() => goTo("services")}
              data-testid="hero-cta-secondary"
              className="btn-secondary"
            >
              See programs
            </button>
          </div>
        </div>
      </div>

      {/* Scroll marker */}
      <div className="absolute bottom-6 right-4 sm:right-12 hidden md:flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-white/40">
        <span>Scroll</span>
        <span className="h-px w-10 bg-white/30" />
      </div>
    </section>
  );
}
